import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'

//import $ from 'jquery'
import jQuery from 'jquery'
global.jQuery = jQuery

 require('./assets/css/bootstrap.min.css');
 require('./assets/fonts/stylesheet.css');
 require('./assets/css/rd-navbar.css');
 require('./assets/css/style.css');

//import { NavbarPlugin } from 'bootstrap-vue'
//Vue.use(NavbarPlugin)

// require('./assets/js/jquery.js');
// require('./assets/js/jquery.rd-navbar.min.js');

Vue.prototype.$http = Axios;

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
